module.exports = __webpack_public_path__ + "static/media/hot_zghsy.5db3525f.png";